export default "__VITE_ASSET__CAdoETPJ__"